import { Record } from 'immutable';

export default class TestGroupRecord extends Record({
  type: '',
  cohort: '',
  status: '',
}) {}
